import React from "react";
import HomeLight from "../all-home-version/HomeLight";

const HomeColor = () => {
  document.body.classList.add("color");
  return (
    <>
      <HomeLight />
    </>
  );
};

export default HomeColor;
